import * as React from 'react';
import { connect } from 'react-redux';
import './ViewPhotos.css';
import { navigateTo } from '../../../actions/navigationActions';
import { showViewInspectionPhoto } from '../../../actions/modalActions';

class ViewPhotos extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleOnPhotoClick = this.handleOnPhotoClick.bind(this);

        this.state = {
            coverToggle: false,
            selectedCover: false,
        }
    }

    handleOnPhotoClick(photoSrc: string) {
        this.props.dispatchShowViewInspectionPhoto(photoSrc);
    }

    public render() {

        let photos = <div></div>
        let row = <div></div>
   
        if (this.props.photoData) {
            photos = this.props.photoData.map((photoItem, index) => {
                    if (photoItem.data) {
                        return <div className="col" onClick={() => this.handleOnPhotoClick(photoItem.image)}>
                            <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                                <img src={photoItem.image} alt={photoItem.data.description} />
                                <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                    <div className="capture-images-block-icon"></div>
                                    <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.data.description}</span>
                                </div>
                            </div>
                        </div>
                    }
                });
            }
      
        return (
            <>
                <div id="viewPhotos" className="container-fluid">
                        <div className="text-center">
                            <div className="row new-page-main-row">
                                <div className="row captureimages-images-block">
                                {photos}
                                </div>
                            </div>
                        </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        selfInspect: state.selfInspect,
        ssp: state.ssp
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowViewInspectionPhoto: (src) => dispatch(showViewInspectionPhoto(src)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewPhotos);